import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  GET_ALL_SHIPMENTS_SERVICES,
  GET_DEFAULT_SERVICES,
  SET_DEFAULT_SERVICES,
} from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IDefaultService, IShipmentService } from "@/types/apiResponse.types";

export const useAllShipmentServicesRequest = (isEditable?: boolean) => {
  return useQuery<{
    data: {
      data: IShipmentService[];
    };
  }>({
    queryKey: [GET_ALL_SHIPMENTS_SERVICES, isEditable],
    queryFn: () =>
      apiRequest(GET_ALL_SHIPMENTS_SERVICES, "get", {
        isEditable,
      }),
  });
};

export const useGetDefaultServicesRequest = () => {
  return useQuery<{
    data: {
      data: IDefaultService;
    };
  }>({
    queryKey: [GET_DEFAULT_SERVICES],
    queryFn: () => apiRequest(GET_DEFAULT_SERVICES, "get"),
  });
};

export const useSetDefaultServicesRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: number[]) =>
      apiRequest(SET_DEFAULT_SERVICES, "put", { serviceIdsIsOn: values }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_DEFAULT_SERVICES] });
    },
  });
};
